
import { METHOD, requestExportPost, requestSet } from '@/utils/request'
import { API_PROXY_PREFIX } from "@/services/api";
export function apiReceiptPlanUnsatisfiedReport (query) {
  return requestSet(`/plan/mom/receipt/plan/receiptPlanUnsatisfiedReport`, METHOD.POST, query)
}
export function apiSumReceiptPlanUnsatisfiedReport (query) {
  return requestSet(`/plan/mom/receipt/plan/sumReceiptPlanUnsatisfiedReport`, METHOD.POST, query)
}
// 导出不满足计划汇总报表
export function apiExportSumReceiptPlanUnsatisfiedReport (params) {
  return requestExportPost(`${API_PROXY_PREFIX}/plan/mom/receipt/plan/exportSumReceiptPlanUnsatisfiedReport`, params)
}
// 自动计算
export function apiCalculate (query) {
  return requestSet(`/plan/v3/receipt/plan/auto/calculate`, METHOD.POST, query)
}
// 导出不满足计划明细报表
export function apiExportReceiptPlanUnsatisfiedReport (query) {
  return requestExportPost(`${API_PROXY_PREFIX}/plan/mom/receipt/plan/exportReceiptPlanUnsatisfiedReport`, query)
}
// 不满足汇报和明细调整
export function apiReceiptPlanUnsatisfiedReportSum (query) {
  return requestSet(`/plan/mom/receipt/plan/receiptPlanUnsatisfiedReport/sum`, METHOD.POST, query)
}
